<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <PageHeader title="Edit Blog Post" subtitle="">
          </PageHeader>

          <Panel class="panel panel-default panel-border-color panel-border-color-primary xs-p-20">
            <div class="setting form-group row form-group-sm">
              <label class="col-xs-6 col-sm-3 col-lg-2 col-form-label" for="txtTitle">Blog post title</label>
              <div class="col-xs-6 col-sm-9 col-lg-10">
                <input type="text" id="txtTitle" class="form-control" v-model="articleDetails.title" />
              </div>
            </div>
            <div class="setting form-group row form-group-sm">
              <label class="col-xs-6 col-sm-3 col-lg-2 col-form-label" for="txtMetaTitle">Meta title</label>
              <div class="col-xs-6 col-sm-9 col-lg-10">
                <input type="text" id="txtMetaTitle" class="form-control" v-model="articleDetails.meta_title" />
              </div>
            </div>
            <div class="setting form-group row form-group-sm">
              <label class="col-xs-6 col-sm-3 col-lg-2 col-form-label" for="txtMetaDescription">Meta description</label>
              <div class="col-xs-6 col-sm-9 col-lg-10">
                <input type="text" id="txtMetaDescription" class="form-control" v-model="articleDetails.meta_desc" />
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-6 col-lg-4 col-form-label" for="txtAuthor">Author</label>
                  <div class="col-xs-6 col-lg-8">
                    <input type="text" id="txtAuthor" class="form-control" v-model="articleDetails.author" />
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-6 col-lg-4 col-form-label" for="chkNotify">Notify admin on create</label>
                  <div class="col-xs-6 col-lg-8">
                    <input type="checkbox" id="chkNotify" class="checkbox" v-model="articleDetails.notify" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row height-100">
              <div class="col-xs-12 height-100">
                <div class="height-100">
                  <FroalaEditor ref="editor" :config="froalaConfig" v-model="articleDetails.content" />
                </div>
              </div>
            </div>
            <div class="alert alert-warning xs-mt-20" v-if="!valid">
              Please fill in all fields above.
            </div>

            <div class="save xs-pt-20">
              <router-link :to="{name: 'blog-manager'}" class="btn btn-xl"><i class="icon mdi mdi-arrow-left"></i> &nbsp;Back</router-link>
              <button class="btn btn-primary btn-xl pull-right xs-ml-10" v-on:click="save()" :disabled="status !== '' || !valid"><i class="fas fa-save"></i> &nbsp; Save</button>
              <button class="btn btn-danger btn-xl pull-right xs-ml-10" v-if="blogArticle && blogArticle.id > 0" v-on:click="deletePost()" :disabled="status !== ''"><i class="fas fa-trash"></i> &nbsp;Delete</button>
              <span class="pull-right xs-mr-10 xs-p-10 text-bold text-muted" style="font-size:15px">{{status}}</span>
              <div class="clearfix"></div>
            </div>
            <hr />
            <BlogCommentsList v-if="blogArticle" :comments="blogArticle.comments" :show-delete="true" :articleId="blogArticle.id"></BlogCommentsList>
          </Panel>
          
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import Blog from '../../../resources/blog'
  import Comment from '../../../resources/comment'
  import FroalaEditor from '../../froala-editor/FroalaEditor'
  import froalaConfig from '../../froala-editor/config/blog-article-editor.js'
  import _ from 'underscore'
  import router from '../../../router'
  import BlogCommentsList from '../../blog/BlogCommentsList'



  export default {
    components: {
      FroalaEditor,
      BlogCommentsList,
    },

    created() {
      this.$store.dispatch('getBlogPosts');

      if (this.$route.params.id) {
        this.postId = this.$route.params.id;
      }

      if (this.blogArticle) {
        this.articleDetails = {
          title: this.blogArticle.title,
          author: this.blogArticle.author,
          notify: this.blogArticle.notify,
          content: this.blogArticle.content,
          meta_title: this.blogArticle.meta_title,
          meta_desc: this.blogArticle.meta_desc,
        };
        this.comments = this.blogArticle.comments;
      }
    },

    methods: {
      save() {
        if (this.valid) {

          this.status = 'saving';
          if (this.postId > 0) {
            const edit = {
              id: this.postId,
              changes: this.articleDetails,
              callback: (err) => {
                this.status = '';
                if (err) {
                  Toast.error(err);
                } else {
                  Toast.success('Blog post updated');
                }
              }
            }
            this.$store.dispatch('updateBlogPost', edit);
          } else {
            const create = {
              blogPost: this.articleDetails,
              callback: (newPost) => {
                this.status = '';
                this.postId = newPost.id;
                this.$store.dispatch('getBlogPosts');
                Toast.success('Blog post created');
              }
            }
            this.$store.dispatch('createBlogPost', create);
          }
        }
      },
      deletePost() {
        if (this.blogArticle && this.blogArticle.id > 0 && confirm('Are you sure you want to delete this blog post?')) {
          this.status = 'deleting';
          this.$store.dispatch('deleteBlogPost', {
            blogPost: this.blogArticle,
            callback: (err) => {
              this.status = '';
              router.push({ name: 'blog-manager' });
              Toast.success('Blog post deleted');
            }});
        }
      },
    },

    computed: {
      ...mapState([
      ]),
      ...mapGetters({
        allBlogPosts: 'allBlogPosts',
      }),

      blogArticle() {
        if (!this.postId || this.postId <= 0) return null;
        return _.first(_.where(this.allBlogPosts, { id: this.postId}));
      },

      valid() {
        if (this.articleDetails.title === '' ||
          this.articleDetails.author === '' ||
          this.articleDetails.content === '') {
          return false;
        }

        return true;
      },
    },

    data() {
      return {
        status: '',
        postId: 0,
        articleDetails: {
          title: '',
          author: '',
          notify: true,
          content: '',
          meta_title: '',
          meta_desc: '',
        },
        comments: [],

        froalaConfig: Object.assign({}, froalaConfig, {
          height: '400px',
        }),
      };
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .checkbox {height:20px;width:20px;}

  .height-100 { height: 100%;}
  .main-content { height: calc(100vh - 180px); }
</style>



// WEBPACK FOOTER //
// posteditor.vue?4f80bd36